import { Button, createTheme, Divider, FormHelperText, InputAdornment, Paper, responsiveFontSizes, TextField, Typography } from '@mui/material'
import { Box, ThemeProvider } from '@mui/system'
import React, { useState } from 'react'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined'
import '../styles/devis.css'
import BadgeIcon from '@mui/icons-material/Badge'
import FmdGoodIcon from '@mui/icons-material/FmdGood'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import FormControl from '@mui/material/FormControl'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import WcOutlinedIcon from '@mui/icons-material/WcOutlined'
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined'
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined'
import LinkIcon from '@mui/icons-material/Link'
import 'jspdf-autotable'
import { doc, setDoc } from 'firebase/firestore'
import { db } from '../firebase-config'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'

let theme = createTheme()
theme = responsiveFontSizes(theme)

export default function DevisForm() {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
        window.location.reload();
      };

    const [textValue, setTextValue] = useState('')

    const handleChangeText = (event) => {
        setTextValue(event.target.value)
    }

    const [cityValue, setCityValue] = useState('')

    const handleChangeCity = (event) => {
        setCityValue(event.target.value)
    }

    const [emailValue, setEmailValue] = useState('')

    const handleChangeEmail = (event) => {
        setEmailValue(event.target.value)
    }

    const [phoneValue, setPhoneValue] = useState('')

    const handleChangePhone = (event) => {
        setPhoneValue(event.target.value)
    }

    const [airbnbLink, setAirbnbLink] = useState('')

    const handleChangeAirbnbLink = (event) => {
        setAirbnbLink(event.target.value)
    }

    const [surfaceValue, setSurfaceValue] = useState(0)

    const handleChangeSurface = (event) => {
        setSurfaceValue(event.target.value)
    }

    const [wcValue, setWcValue] = useState(0)

    const handleChangeWc = (event) => {
        setWcValue(event.target.value)
    }

    const [sdbValue, setSdbValue] = useState(0)

    const handleChangeSdb = (event) => {
        setSdbValue(event.target.value)
    }

    const [state, setState] = useState({
        presta: true,
        gc: false,
    })

    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.checked,
        })
    }

    const { presta, gc } = state
    const error = [presta, gc].filter((v) => v).length !== 1

    const [stateDressage, setStateDressage] = useState({
        oui: true,
        non: false,
    })

    const handleChangeDressage = (event) => {
        setStateDressage({
            ...stateDressage,
            [event.target.name]: event.target.checked,
        })
    }

    const { oui, non } = stateDressage
    const errorDressage = [oui, non].filter((v) => v).length !== 1

    const [stateLinge, setStateLinge] = useState({
        dnrr: true,
        dr: false,
        none: false,
    })

    const handleChangeLinge = (event) => {
        setStateLinge({
            ...stateLinge,
            [event.target.name]: event.target.checked,
        })
    }

    const { dnrr, dr, none } = stateLinge
    const errorLinge = [dnrr, dr, none].filter((v) => v).length !== 1

    const [stateContact, setStateContact] = useState({
        oui: true,
        non: false,
    })

    const handleChangeContact = (event) => {
        setStateContact({
            ...stateContact,
            [event.target.name]: event.target.checked,
        })
    }

    const { ouiContact, nonContact } = stateContact
    const errorContact = [ouiContact, nonContact].filter((v) => v).length !== 1

    const [stateTime, setStateTime] = useState({
        matin: true,
        SpeechRecognitionResultList: false,
    })

    const handleChangeTime = (event) => {
        setStateTime({
            ...stateTime,
            [event.target.name]: event.target.checked,
        })
    }

    const { ouiTime, nonTime } = stateTime

    const checkedFormule = Object.keys(state).find(key => state[key] === true)

    const checkedLinge = Object.keys(stateLinge).find(key => stateLinge[key] === true)
    const checkedDressage = Object.keys(stateDressage).find(key => stateDressage[key] === true)
    const checkedRecontact = Object.keys(stateContact).find(key => stateContact[key] === true)
    const checkedRecontactTime = Object.keys(stateTime).find(key => stateTime[key] === true)
    
    function handleSubmit() {
        if(validateInfos()) {
            addToDevis();
            handleClickOpen();
        }
    }

    const today = new Date()
    const time = (today.getHours() + today.getMinutes() + today.getSeconds()).toString()

    const addToDevis = () => {
        const devisRef = doc(db, 'Devis', time)
        setDoc(devisRef, {
            nom: textValue,
            ville: cityValue,
            mail: emailValue,
            telephone: phoneValue,
            airbnb: airbnbLink,
            formule_menage: checkedFormule,
            surface: surfaceValue,
            wc: wcValue,
            sdb: sdbValue,
            dressage_lits: checkedDressage,
            gestion_linge: checkedLinge,
            recontact: checkedRecontact,
            recontact_moment: checkedRecontactTime
        })
    }

    function validateInfos() {
        if(textValue !== '' && cityValue !== '' && emailValue !== '' && phoneValue !== '' && surfaceValue !== 0 && sdbValue !== 0 && wcValue !== 0) {
            return true
        } else {
            if(textValue === '') {
                alert("Veuillez indiquer votre nom s'il vous plaît")
            } else if(cityValue === '') {
                alert("Veuillez indiquer la ville s'il vous plaît")
            } else if(emailValue === '') {
                alert("Veuillez indiquer une adresse mail valide s'il vous plaît")
            } else if(phoneValue === '') {
                alert("Veuillez entrer un numéro de téléphone s'il vous plaît")
            } else if(surfaceValue === 0) {
                alert("Veuillez indiquer la surface de votre bien s'il vous plaît")
            } else if(sdbValue === 0) {
                alert("Veuillez indiquer le nombre de salles de bain s'il vous plaît")
            } else if(wcValue === 0) {
                alert("Veuillez indiquer le nombre de toilettes s'il vous plaît")
            }
        }
    }

    function handleLink() {
        window.location.href = 'https://welchome29.fr/contact.html'
    }

  return (
        <Box sx={{ 
            width: '80%' ,
            margin: '50px auto', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            gap: '25px' 
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: '50px', flexWrap: 'wrap' }}>
                <Paper elevation={3} sx={{ width: 350, borderRadius: '40px', padding: '30px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', marginBottom: '25px' }}>
                        <LightbulbOutlinedIcon sx={{ background: '#E0CFFF', padding: '5px', borderRadius: '5px' }} />
                        <ThemeProvider theme={theme}>
                            <Typography variant='h5'>
                                important!
                            </Typography>
                        </ThemeProvider>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                        <ThemeProvider theme={theme}>
                            <Typography variant='body' sx={{ fontSize: '1.1rem' }}>
                                  Veuillez remplir tous les champs afin que l'application puisse générer votre devis au format PDF.
                            </Typography>
                            <Typography variant='body' sx={{ fontSize: '1.1rem' }}>
                                  Ce devis généré est estimatif et donne une idée globale. Le devis final sera effectué seulement après visite de votre bien.
                            </Typography>
                        </ThemeProvider>
                    </Box>
                </Paper>
                <Paper elevation={3} sx={{ width: 350, borderRadius: '40px', padding: '30px' }}>
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '15px', 
                        flexWrap: 'nowrap', 
                        marginBottom: '25px' 
                    }}>
                        <MessageOutlinedIcon sx={{ background: '#FFCCCC', padding: '5px', borderRadius: '5px' }} />
                        <ThemeProvider theme={theme}>
                            <Typography variant='h5'>
                                On reste en contact ?
                            </Typography>
                        </ThemeProvider>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                        <ThemeProvider theme={theme}>
                            <Typography variant='body' sx={{ fontSize: '1.1rem' }}>
                                  Une question, une interrogation ou l'envie de nous dire bonjour ? Cela nous fera toujours plaisir d'avoir de vos nouvelles. 
                            </Typography>
                            <Typography variant='body' sx={{ fontSize: '1.1rem' }}>
                                  N'hésitez donc pas à nous contacter via ce formulaire, nous vous répondrons rapidement.
                            </Typography>
                            <Button variant='contained' sx={{ maxWidth: '100px'  }} onClick={handleLink}>contact</Button>
                        </ThemeProvider>
                    </Box>
                </Paper>
            </Box>
            <Divider sx={{ width: '80%', margin: '0 auto', borderBottomWidth: '5px', marginTop: '25px' }} />
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Pour commencer, quel est votre nom ?
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <BadgeIcon sx={{ background: '#9DFFDB', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Nom de famille' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }}
                        value={textValue}
                        onChange={handleChangeText} 
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Dans quelle ville se situe votre bien ?
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <FmdGoodIcon sx={{ background: '#FFD29D', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Ville' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }}
                        value={cityValue}
                        onChange={handleChangeCity}
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Indiquez nous votre meilleure adresse mail<br />Pas d'inquiétude, vous ne recevrez aucune pub de notre part
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <AlternateEmailIcon sx={{ background: '#D59DFF', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Email' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }} 
                        type='email'
                        value={emailValue}
                        onChange={handleChangeEmail}
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Disposez-vous déjà d'une annonce sur une plateforme (Airbnb, Abritel...) ? Si oui, merci d'indiquer le lien
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <LinkIcon sx={{ background: '#FF775A', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Lien Plateforme' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }} 
                        value={airbnbLink}
                        onChange={handleChangeAirbnbLink}
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Indiquez votre numéro de portable, cela nous permettra de vous recontacter
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <PhoneAndroidOutlinedIcon sx={{ background: '#9DFFF9', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Numéro de téléphone' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }}
                        value={phoneValue}
                        onChange={handleChangePhone} 
                    />
                </Box>
            </Box>
            <Divider sx={{ width: '80%', margin: '0 auto', borderBottomWidth: '5px', marginTop: '25px' }} />
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Choisissez la formule que vous souhaitez
                    </Typography>
                </ThemeProvider>
                <FormControl
                    required
                    error={error}
                    component='fieldset' 
                    sx={{ '& .MuiFormControlLabel-root': { mb: 2 } }}
                >
                    <FormGroup>
                      <FormControlLabel
                          control={
                              <Checkbox checked={presta} onChange={handleChange} name='presta' />
                          }
                          label='Formule Prestation (Check-in + Check-out + Ménage)'
                      />
                      <FormControlLabel
                          control={
                              <Checkbox color='success' checked={gc} onChange={handleChange} name='gc' />
                          }
                          label='Formule Gestion complète'
                      />
                    </FormGroup>
                    <FormHelperText>Vous ne pouvez choisir qu'une seule formule</FormHelperText>
                </FormControl>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Quelle est la surface au sol de votre bien ?
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <SquareFootIcon sx={{ background: '#FEFF9D', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Surface' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position='start'>m²</InputAdornment>
                        }}
                        value={surfaceValue}
                        onChange={handleChangeSurface} 
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Combien de toilettes possèdent le logement ?
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <WcOutlinedIcon sx={{ background: '#9DBCFF', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Nombre de toilettes' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }}
                        type='number' 
                        value={wcValue}
                        onChange={handleChangeWc}
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Combien y a-t-il de salles de bain dans le logement ?
                    </Typography>
                </ThemeProvider>
                <Box display='flex' alignItems='center' gap='15px'>
                    <BathtubOutlinedIcon sx={{ background: '#B2FF9D', padding: '5px', borderRadius: '5px' }} />
                    <TextField 
                        variant='outlined' 
                        label='Nombre de salles de bain' 
                        sx={{
                            width: '300px',
                            '& .MuiInputBase-root': { 
                                borderRadius: '40px' 
                            } 
                        }}
                        type='number'
                        value={sdbValue}
                        onChange={handleChangeSdb} 
                    />
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Faut-il que nos équipes s'occupent du dressage des lits ?
                    </Typography>
                </ThemeProvider>
                <FormControl
                    required
                    error={errorDressage}
                    component='fieldset' 
                    sx={{ '& .MuiFormControlLabel-root': { mb: 2 } }}
                >
                    <FormGroup>
                      <FormControlLabel
                          control={
                              <Checkbox color='success' checked={oui} onChange={handleChangeDressage} name='oui' />
                          }
                          label='Oui'
                      />
                      <FormControlLabel
                          control={
                              <Checkbox color='success' checked={non} onChange={handleChangeDressage} name='non' />
                          }
                          label='Non'
                      />
                    </FormGroup>
                    <FormHelperText>Vous ne pouvez choisir qu'une seule réponse</FormHelperText>
                </FormControl>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Souhaitez-vous que l'on s'occupe de la gestion de votre linge ?
                    </Typography>
                </ThemeProvider>
                <FormControl
                    required
                    error={errorLinge}
                    component='fieldset' 
                    sx={{ '& .MuiFormControlLabel-root': { mb: 2 } }}
                >
                    <FormGroup>
                      <FormControlLabel
                          control={
                              <Checkbox color='default' checked={dnrr} onChange={handleChangeLinge} name='dnrr' />
                          }
                          label='Dépôt + Nettoyage + Repassage + Récupération'
                      />
                      <FormControlLabel
                          control={
                              <Checkbox color='default' checked={dr} onChange={handleChangeLinge} name='dr' />
                          }
                          label='Dépôt + Récupération'
                      />
                      <FormControlLabel
                          control={
                              <Checkbox color='default' checked={none} onChange={handleChangeLinge} name='none' />
                          }
                          label="Non merci j'ai déjà une autre solution"
                      />
                    </FormGroup>
                    <FormHelperText>Vous ne pouvez choisir qu'une seule formule</FormHelperText>
                </FormControl>
            </Box>
            <Divider sx={{ width: '80%', margin: '0 auto', borderBottomWidth: '5px', marginTop: '25px' }} />
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '25px', 
                alignItems: 'center', 
                marginTop: '25px',
                textAlign: 'center',
                width: '80%'
            }}>
                <ThemeProvider theme={theme}>
                    <Typography variant='h5'>
                        Souhaitez-vous être recontacté par téléphone ?
                    </Typography>
                </ThemeProvider>
                <FormControl
                    required
                    error={errorContact}
                    component='fieldset' 
                    sx={{ '& .MuiFormControlLabel-root': { mb: 2 } }}
                >
                    <FormGroup>
                      <FormControlLabel
                          control={
                              <Checkbox color='success' checked={ouiContact} onChange={handleChangeContact} name='ouiContact' />
                          }
                          label='Oui'
                      />
                      {ouiContact && (
                        <FormGroup sx={{ marginLeft: '50px' }}>
                            <FormControlLabel
                                control= {
                                    <Checkbox color='secondary' checked={ouiTime} onChange={handleChangeTime} name='ouiTime' />
                                }
                                label='Matin'
                            />
                            <FormControlLabel
                                control= {
                                    <Checkbox color='secondary' checked={nonTime} onChange={handleChangeTime} name='nonTime' />
                                }
                                label='Soir'
                            />
                        </FormGroup>
                      )}
                      <FormControlLabel
                          control={
                              <Checkbox color='success' checked={nonContact} onChange={handleChangeContact} name='nonContact' />
                          }
                          label='Non'
                      />
                    </FormGroup>
                    <FormHelperText>Vous ne pouvez choisir qu'une seule réponse</FormHelperText>
                </FormControl>
            </Box>
            <Button 
                variant='contained' 
                sx={{ 
                    paddingX: '30px', 
                    paddingY: '15px', 
                    fontSize: '1.2rem', 
                    marginTop: '25px', 
                    width: '50%', 
                    borderRadius: '40px' 
                }}
                onClick={handleSubmit}
            >
                Demander mon devis
            </Button>
          <Dialog open={open} onClose={handleClose}>
              <DialogTitle>CONFIRMATION</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Merci pour votre demande de devis. Votre demande a bien été transmise. Nous reviendrons vers vous dans les plus brefs délais.
                  </DialogContentText>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleClose} color="primary">
                      Fermer
                  </Button>
              </DialogActions>
          </Dialog>
        </Box>
  )
}
